import React, { useRef } from "react";
import {  Button, Card } from "antd";
import { motion } from "framer-motion";


const AboutUs = () => {

  const aboutUsSectionRef = useRef(null);
  // Inline Styles
  const pageContainerStyle = {
    textAlign: "center",
    padding: "40px 10px",
    background: "#f8f9fa",
    width: "100%",
    overflow: "hidden",
  };
  const features = [
    {
      title: "Travel Plan",
      description: "Add schedule details with date, time, and route. Sync with personal and office calendars. Notify concerned persons or groups. Associate vehicles and volunteers.",
      icon: "🗺️"
    },
    {
      title: "Transport",
      description: "Manage vehicle inventory and movement records with GPS tracking. Maintain driver and whereabouts details.",
      icon: "🚗"
    },
    {
      title: "Appointment Management",
      description: "Find and schedule availability. Modify, cancel, or make appointments private. ",
      icon: "📅"
    },
    {
      title: "Grievance Management",
      description: "Allow users to raise concerns via an open link with OTP verification. Assign or redirect grievances, track status, highlight long-pending items, and send auto reminders.",
      icon: "📢"
    },
    {
      title: "Messaging System",
      description: "Send personalized messages using templates to engage effectively.",
      icon: "💬"
    },
    {
      title: "Survey & Insights",
      description: "Create survey links, gather responses, and analyze reports.",
      icon: "📊"
    }
  ];
  

  const heroStyle = {
    position: "relative",
    backgroundImage: 'url("https://w0.peakpx.com/wallpaper/956/766/HD-wallpaper-satyamev-jayate-akshay-pandharinath-karpe-com-government-of-india-indian-government-logo.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "50vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    animation: "fadeIn 1.5s ease-in-out",
  };

  const heroOverlayStyle = {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    padding: "40px",
    borderRadius: "10px",
    textAlign: "center",
    color: "#fff",
    transform: "scale(1)",
    transition: "transform 0.3s ease-in-out",
  };

  const buttonHoverStyle = {
    background: "#1890ff",
    border: "none",
    transition: "background 0.3s ease-in-out, transform 0.2s ease-in-out",
  };

  const sectionStyle = {
    padding: "60px 20px",
    textAlign: "center",
    backgroundColor: "#f9f9f9",
    animation: "fadeUp 1s ease-in-out",
  };

  const sectionHeadingStyle = {
    fontSize: "32px",
    marginBottom: "20px",
    color: "#222",
  };

  // const cardStyle = {
  //   borderRadius: "10px",
  //   overflow: "hidden",
  //   transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
  //   cursor: "pointer",
  //   textAlign: "center",
  //   position: "relative",
  //   background: "#fff",
  // };

  // const cardHoverStyle = {
  //   boxShadow: "0px 10px 25px rgba(24, 144, 255, 0.3)",
  //   transform: "scale(1.05)",
  // };

  // const cardImageStyle = {
  //   width: "100%",
  //   height: "200px",
  //   objectFit: "cover",
  //   transition: "transform 0.3s ease-in-out",
  // };

  // const statCardStyle = {
  //   background: "#f0f2f5",
  //   borderRadius: "10px",
  //   padding: "20px",
  //   textAlign: "center",
  //   transform: "scale(1)",
  //   margin: "10px 0",
  // };

  // const statHoverStyle = {
  //   transform: "scale(1.06)",
  //   transition: "transform 0.3s ease-in-out",
  // };

  // const statIconStyle = {
  //   fontSize: "36px",
  //   color: "#1890ff",
  //   marginBottom: "10px",
  // };

  // // Dummy candidate data
  // const candidates = [
  //   { 
  //     name: "John Doe", 
  //     party: "Party A", 
  //     img: "https://randomuser.me/api/portraits/men/10.jpg" 
  //   },
  //   { 
  //     name: "Jane Smith", 
  //     party: "Party B", 
  //     img: "https://randomuser.me/api/portraits/women/12.jpg" 
  //   },
  //   { 
  //     name: "Robert Johnson", 
  //     party: "Party C", 
  //     img: "https://randomuser.me/api/portraits/men/15.jpg" 
  //   }
  // ];
  const handleScrollToAboutUs = () => {
    aboutUsSectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };


  return (
    <div style={pageContainerStyle}>
      {/* Hero Section */}
      <div style={heroStyle}>
        <div style={heroOverlayStyle}>
          <h1 style={{ fontSize: "48px", marginBottom: "20px" }}>BJP ODISHA</h1>
          <p style={{ fontSize: "24px", marginBottom: "30px" }}>Stay Organized, Stay Ahead</p>
          <Button
  type="primary"
  size="large"
  style={{
    background: "transparent",
    color: "white",
    border: "2px solid white",
    transition: "all 0.3s ease-in-out",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background = "white";
    e.currentTarget.style.color = "#063970"; // Change text color on hover
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "transparent";
    e.currentTarget.style.color = "white";
  }}
  onClick={handleScrollToAboutUs}
>
  About Us
</Button>
        </div>
      </div>

      {/* About Section */}
     <div style={sectionStyle}ref={aboutUsSectionRef}>
     <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      style={{
        padding: "60px 20px",
        textAlign: "center",
        background: "linear-gradient(to right,rgb(31, 31, 29),rgb(198, 197, 193))",
        color: "white",
        borderRadius: "10px",
      }}
    >
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.3 }}
        style={{ fontSize: "36px", fontWeight: "bold", marginBottom: "20px",color:"#CC7722" }}
      >
        A Smarter Way to Serve & Lead
      </motion.h2>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.6 }}
        style={{ fontSize: "18px", maxWidth: "800px", margin: "0 auto 40px", color: "#f8f8f8" }}
      >
       Monitor grievances, track vehicles, and manage volunteers with ease.


      </motion.p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px", maxWidth: "1000px", margin: "auto" }}>
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
          >
            <Card
              style={{ background: "rgba(149, 110, 9, 0.13)", borderRadius: "10px", padding: "20px", color: "white", border: "none" }}
            >
              <h3 style={{ fontSize: "20px", marginBottom: "10px" }}>{feature.icon} {feature.title}</h3>
              <p style={{ fontSize: "16px", color: "#f8f8f8" }}>{feature.description}</p>
            </Card>
          </motion.div>
        ))}
      </div>
    </motion.div>
     </div>

      {/* Candidates Section */}
      {/* <div style={sectionStyle} ref={candidatesSectionRef}>
        <h2 style={sectionHeadingStyle}>Featured Candidates</h2>
        <Row gutter={[16, 16]} justify="center">
          {candidates.map((candidate, index) => (
            <Col key={index} xs={24} sm={12} md={8}>
              <Card
                hoverable
                style={cardStyle}
                onMouseEnter={(e) => (e.currentTarget.style = { ...cardStyle, ...cardHoverStyle })}
                onMouseLeave={(e) => (e.currentTarget.style = cardStyle)}
                cover={<img alt={candidate.name} src={candidate.img} style={cardImageStyle} />}
              >
                <h3>{candidate.name}</h3>
                <p>{candidate.party}</p>
                <Button type="primary" style={buttonHoverStyle}>
                  View Profile
                </Button>
              </Card>
            </Col>
          ))}
        </Row>
      </div> */}

      {/* Statistics Section */}
      {/* <div style={{ ...sectionStyle, backgroundColor: "#fff" }}>
        <Row gutter={[16, 16]} justify="center">
          <Col xs={24} sm={8}>
            <div
              style={statCardStyle}
              onMouseEnter={(e) => Object.assign(e.currentTarget.style, statHoverStyle)}
              onMouseLeave={(e) => Object.assign(e.currentTarget.style, statCardStyle)}
            >
              <PieChartOutlined style={statIconStyle} />
              <h3>Vote Count</h3>
              <p>1,234,567</p>
            </div>
          </Col>
          <Col xs={24} sm={8}>
            <div
              style={statCardStyle}
              onMouseEnter={(e) => Object.assign(e.currentTarget.style, statHoverStyle)}
              onMouseLeave={(e) => Object.assign(e.currentTarget.style, statCardStyle)}
            >
              <TeamOutlined style={statIconStyle} />
              <h3>Registered Voters</h3>
              <p>2,345,678</p>
            </div>
          </Col>
          <Col xs={24} sm={8}>
            <div
              style={statCardStyle}
              onMouseEnter={(e) => Object.assign(e.currentTarget.style, statHoverStyle)}
                onMouseLeave={(e) => Object.assign(e.currentTarget.style, statCardStyle)}
            >
              <UserOutlined style={statIconStyle} />
              <h3>Active Users</h3>
              <p>89,012</p>
            </div>
          </Col>
        </Row>
      </div> */}
    </div>
  );
};

export default AboutUs;
